<template>
    <div>
        <div v-for="(sample, index) in samples" :key="sample.id" class="mt-3 sample-item">
            <sample-item :sample="sample"
                         :ref="uniqueId()"
                         :readonly="readonly"
                         :can-move-up="samples.length > 0 && index < samples.length - 1"
                         :can-move-down="samples.length > 0 && index > 0"
                         @delete="handleDeleteSample"
                         @validation-changed="handleItemValidationChanged(sample, $event)"
                         @move-down="$emit('move-down', sample.id)"
                         @move-up="$emit('move-up', sample.id)"></sample-item>
            <v-divider v-if="index != (samples.length - 1)"></v-divider>
        </div>
    </div>
</template>

<script>
    import SampleItem from './SampleItem'
    import _ from 'lodash'

    export default {
        name: 'SamplesList',
        props: {
            samples: Array,
            readonly: Boolean
        },
        components: {
            SampleItem
        },
        data() {
            return {
                itemsValid: false
            }
        },
        mounted() {
            this.itemsValid = this.validate()
        },
        methods: {
            validate(silent = false) {
                let result = true

                for (let key in this.$refs) {
                    if (!this.$refs.hasOwnProperty(key)) {
                        continue
                    }

                    const item = _.get(this.$refs, [key, 0])

                    if (!item) {
                        delete this.$refs[key]
                        continue
                    }

                    if (!item.validate()) {
                        result = false
                        break
                    }
                }

                if (this.itemsValid !== result) {
                    this.itemsValid = result

                    if (!silent) {
                        this.$emit('validation-changed', result)
                    }
                }

                return result
            },
            handleItemValidationChanged(sample, value) {
                this.$emit('validation-changed', this.isValid())
            },
            uniqueId() {
                return _.uniqueId('item-')
            },
            isValid() {
                let result = true
                for (let key in this.$refs) {
                    if (!this.$refs.hasOwnProperty(key)) {
                        continue
                    }

                    const item = _.get(this.$refs, [key, 0])

                    if (!item) {
                        delete this.$refs[key]
                        continue
                    }

                    if (!item.isValid()) {
                        result = false
                        break
                    }
                }

                this.itemsValid = result
                return this.itemsValid && this.samples && this.samples.length > 0
            },
            async handleDeleteSample(id) {
                this.$emit('delete', id)

                await this.$nextTick()
                this.validate()
            },
        }
    }
</script>

<style scoped>

</style>